import { ReactNode } from "react";
import { toast } from "@erelego/design-system/components/atoms/Toast/toast";
import { ToastTypeEnum } from "@erelego/design-system/components/atoms/Toast/interface";
import "./styles.scss";
export const displaySuccessMessage = (
  content: string | ReactNode,
  onClose?: () => void
) => {
  return toast(ToastTypeEnum.success, {
    title: content,
    description: "",
    onClose: onClose,
  });
};
export const displayErrorMessage = (
  content: string | ReactNode,
  onClose?: () => void
) => {
  return toast(ToastTypeEnum.error, {
    title: content,
    description: "",
    onClose: onClose,
  });
};
